import { IoCameraOutline } from 'react-icons/io5';
import { ImageTemp, ImageType } from '../../../interfaces/intakes.reports';
import { Gallery } from '../../Gallery';
import { useDeleteBatchImage } from '../../../api/useDeleteImage';
import { useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import { ModalImages } from '../../modals/ModalImages';
import { useAddBatchImages } from '../../../api/useFetchImages';
import toast from 'react-hot-toast';

interface Props {
    images: ImageType[]
    reportId: string
}

export const MainDataImages = ({ images, reportId }: Props) => {

    const { mutateAsync:mutateDeleting } = useDeleteBatchImage()
    const { mutateAsync, isLoading } = useAddBatchImages()
    const queryClient = useQueryClient()
    const [openImagesModal, setOpenImagesModal] = useState<boolean>(false)

    const deleteImage = async (image: ImageType) => {
        await mutateDeleting({
            keyName: image.key,
            keyLow: image.key_low,
            reportId,
        }, {
            onSuccess: async () => {
                await queryClient.invalidateQueries(['reportTemp', reportId])
                await queryClient.invalidateQueries(['report', reportId])
            }
        })
    };

    const handleImages = async (images: ImageTemp[]) => {
        if (images.length === 0) {
            toast.error('No images selected')
            return
        }
        await mutateAsync({
            images,
            reportId
        }, {
            onSuccess: async () => {
                await queryClient.invalidateQueries(['reportTemp', reportId])
                await queryClient.invalidateQueries(['report', reportId])
                setOpenImagesModal(false)
            }
        })
    };

    return (
        <div>
            <div className='tw-mb-5'>
                <Gallery
                images={images}
                deleteImage={deleteImage}
                fullwidth
                reportId={reportId}
            />
            </div>

            {
                openImagesModal &&
                <ModalImages
                    closeModal={() => setOpenImagesModal(false)}
                    handleImages={handleImages}
                    isLoading={isLoading}
                    limit={20 - images.length}
                />
            }

            <button className="upload-label tw-mb-3" onClick={() => setOpenImagesModal(true)}>
                <IoCameraOutline fontSize={22} />
                <span>Add Batch Images</span>
            </button>
        </div>
    )
}